import {useTransformQuery} from 'web-app/react/hooks/use-transform-query';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import type {GetFinanceOverviewChildrenQuery} from '../queries/__generated__/get-finance-overview-child.query.api-types';
import type {GetFinanceOverviewChildrenQueryVariables} from '../queries/__generated__/get-finance-overview-child.query.api-types';
import {GetFinanceOverviewChildren} from '../queries/get-finance-overview-child.query';

const useFinanceOverviewChildren = (siteId: string, childIds: Array<string>) => {
    const [children, {loading: isChildrenLoading, refetch}] = useTransformQuery<
        GetFinanceOverviewChildrenQuery,
        GetFinanceOverviewChildrenQueryVariables
    >()(
        GetFinanceOverviewChildren,
        {
            variables: {
                siteId,
                childIds,
            },
            fetchPolicy: 'cache-and-network',
        },
        ({data}) => {
            if (!hasValue(data)) {
                return [];
            }
            return data.finance.financeOverviewVersioned.v2.detachedFinanceOverviewChildren;
        },
    );

    return {children, isChildrenLoading, refetch};
};

export {useFinanceOverviewChildren};
